/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';

import {AdnApiClientService} from '../common/controller/adn-api-client.service';
import {
  SignalAdminResourceApiBase,
  SignalAdminResourceModel
} from '../common/controller/signal-admin-resource-api';

export interface LineItemReviewModel extends SignalAdminResourceModel {
  [key: string]: any;
}

@Injectable({providedIn: 'root'})
export class LineItemReviewApiService extends SignalAdminResourceApiBase<LineItemReviewModel> {
  constructor(client: AdnApiClientService) {
    super(client, 'lineitems/review', {showBudgetSpend: true});
  }
}
